<template>
    <div>
        <b-row>
            <b-col cols="12" class="text-center mb-3">
                <h2><b>CRIAR ROTAS DA NAVBAR</b></h2>
                <b-button @click="createOrEdit()">Criar</b-button>
            </b-col>
            <b-col cols="12" class="d-flex justify-content-center">
                <b-table 
                    :items="menus"
                    :fields="header"
                    striped
                    hover
                    bordered
                    small
                    style="max-width: 1080px;"
                >
                    <template #cell(edit)="data">
                        <div>
                            <b-button @click="createOrEdit(data.item.id)"><i class="fas fa-edit fa-1x"></i></b-button>
                            <b-button @click="trashMenu(data.item.id)" variant="danger"><i class="fas fa-trash fa-1x"></i></b-button>
                        </div>
                    </template>                
                    <template #cell(icon)="data">
                        <div class="d-flex">
                            <i :class="`fas ${data.item.icon} fa-1x mx-2`"></i>
                            <h6>{{ data.item.icon }}</h6>
                        </div>
                    </template>                
                </b-table>
            </b-col>
        </b-row>
        <b-modal id="create_rota" title="Criar Rotas" size="lg" hide-footer centered>
            <b-row>
                <b-col>
                    <label for="">Rótulo*</label>
                    <b-input v-model="label"></b-input>
                </b-col>
                <b-col v-show="submenu">
                    <label for="">Rota*</label>
                    <b-input v-model="rota"></b-input>
                </b-col>
                <b-col>
                    <label for="">Icone</label>
                    <b-input v-model="icon"></b-input>
                </b-col>
                <b-col>
                    <label for="">Prioridade</label>
                    <b-select v-model="prioridade" :options="prioridades"></b-select>
                </b-col>
                <b-col>
                    <label for="">Permissao</label>
                    <b-select v-model="permission_id" :options="roles"></b-select>
                </b-col>
                <b-col cols="12" class="align-self-center ">
                    <b-checkbox switch v-model="submenu">Sem Sub-Menu</b-checkbox>
                </b-col>
                <b-col cols="12" class="text-left mt-5" v-show="!submenu">
                    <h6 class="m-0 mb-2"><b>SUB-MENUS:</b></h6>
                    <b-row v-for="(item, index) in items" :key="index" class="mb-2 border-top py-2">
                        <b-col cols="12" class="d-flex justify-content-end">
                            <i v-if="items.length > 1" style="cursor: pointer;" @click="eraseItem(index)" class="fas fa-times fa-1x"></i>
                        </b-col>
                        <b-col class="text-left">
                            <label for="">Rótulo*</label>
                            <b-input v-model="item.label"></b-input>
                        </b-col>
                        <b-col class="text-left">
                            <label for="">Rota*</label>
                            <b-input v-model="item.rota"></b-input>
                        </b-col>
                        <b-col class="text-left">
                            <label for="">Permissão*</label>
                            <b-select v-model="item.permission_id" :options="roles"></b-select>
                        </b-col>
                    </b-row>
                    <div class="text-center">
                        <b-button @click="addItem"><i class="fas fa-plus fa-1x"></i></b-button>
                    </div>
                </b-col>
                <b-col cols="12" class="text-center mt-3">
                    <b-button @click="closeModal()">Cancelar</b-button>
                    <b-button @click="save()" variant="primary">Salvar</b-button>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
export default {
    data() {
        return{
            submenu: false,
            id: null,
            header:[
                {
                    label: 'Codigo',
                    key: 'id'
                },
                {
                    label: 'Menu',
                    key: 'label'
                },
                {
                    label: 'Icone',
                    key: 'icon'
                },
                {
                    label: 'Permissão',
                    key: 'permission.label'
                },
                {
                    label: 'Prioridade',
                    key: 'prioridade'
                },
                {
                    label: 'Sub-Menus',
                    key: 'submenus',
                    formatter: (value, key, item) => {
                        if(value.length > 0){
                            return value.length
                        }else{
                            return 'Sem Sub-Menu'
                        }
                    }
                },
                {
                    label: 'Edição',
                    key: 'edit'
                }
            ],
            items:[
                {
                    label: '',
                    rota: '',
                    permission_id: null
                }
            ],
            permission_id: null,
            prioridade: 0,
            prioridades: [],
            roles: [
                {
                    text: 'Sem Permissão',
                    value: null
                }
            ],
            options_menu: [
                {
                    value: null,
                    text: 'Rota Direta'
                }
            ],
            menus: [],
            label: '',
            rota: '',
            icon: '',
        }
    },
    computed:{
    },
    methods:{
        closeModal(){
            this.$bvModal.hide('create_rota')
        },
        openModal(){
            this.$bvModal.show('create_rota')
        },
        trashMenu(id){
            this.$swal.fire({
                icon: 'question',
                title: "Deseja realmente deletar o menu de ID "+id+"?",
                footer: "Esta ação não poderá ser revertida!",
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: "Sim, Confirmo",
                denyButtonText: "Cancelar",
            }).then((result) => {
                if (result.isConfirmed) {
                    axios
                        .delete(`/adm/navbar/${id}`)                
                        .then(resp => {
                            this.getMenus()
                        })
                        .catch(error => {
        
                        })
                }
            })
        },
        createOrEdit(id){
            if(id){
                axios
                    .get(`/adm/navbar/${id}`)                
                    .then(resp => {
                        if(resp.data){
                            this.id = resp.data.id

                            this.permission_id = resp.data.permission_id
                            this.prioridade = resp.data.prioridade
                            this.label = resp.data.label
                            this.icon = resp.data.icon

                            if(resp.data.submenus.length > 0){
                                this.submenu = false
                                this.rota = null
                                this.items = resp.data.submenus
                            }else{
                                this.submenu = true
                                this.rota = resp.data.rota
                                this.items = [
                                    {
                                        label: '',
                                        rota: '',
                                        permission_id: null
                                    }
                                ]
                            }

                            this.openModal()
                        }
                    })
                    .catch(error => {
                        
                    })
            }else{
                this.clear()
                this.openModal()
            }
        },
        addItem(){
            this.items.push({
                label: '',
                rota: ''
            })
        },
        eraseItem(index){
            this.items.splice(index, 1);
        },
        clear(){
            this.submenu = false
            this.permission_id = null
            this.prioridade = 0
            this.label = ''
            this.rota = ''
            this.icon = ''
            this.id = null

            this.options_menu = [
                {
                    label: '',
                    rota: '',
                    permission_id: null
                }
            ]

        },
        save(){
            const data = {}

            data.check = this.submenu
            data.permission_id = this.permission_id
            data.prioridade = this.prioridade
            data.rota = this.rota
            data.icon = this.icon

            if(this.label){
                data.label = this.label
            }else{
                alert("Rotulo do Menu em branco!");
                return
            }

            if(this.submenu){
                if(!data.rota){
                    alert("Rotulo do Menu em branco!");
                    return
                }
            }else{
                this.items.forEach(element => {
                    if(!element.label || !element.rota){
                        alert("Rotulo ou Rota dos Sub-Menus estão branco!")
                        return
                    }
                });
                
                data.items = this.items
            }
    
            if(this.id){
                axios
                    .put(`/adm/navbar/${this.id}`, data)                
                    .then(resp => {
                        this.closeModal()
                        this.getMenus()
                    })
                    .catch(error => {
    
                    })
            }else{
                axios
                    .post("/adm/navbar", data)                
                    .then(resp => {
                        this.closeModal()
                        this.getMenus()
                    })
                    .catch(error => {
    
                    })
            }
        },
        getMenus(){
            axios
                .get("/get_menus")                
                .then(resp => {
                    this.menus = resp.data
                    for (let index = 0; index < this.menus.length; index++) {
                        this.prioridades.push({
                            text: index,
                            value: index
                        })
                    }
                })
                .catch(error => {
                    
                })
        },
        getPermissions(){
            axios
                .get("users/all_acessos")                
                .then(resp => {
                    if(resp.data){
                        resp.data.forEach(element => {
                            this.roles.push({
                                text: '('+element.name+') '+element.label,
                                value: element.id
                            })
                        });
                    }
                })
                .catch(error => {
                    
                })
        }
    },
    mounted(){
        this.getMenus()
        this.getPermissions()
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/adm_vertical_navbar/create.vue